import Label from "./utils/Label.js";
import Button from "./utils/Button.js";
import InputText from "./utils/InputText.js";
import Funnel from "../services/funnel-service.js";

const template = `
    <div class="grid" v-show="fs.display(input)">
        <div :class="input.left_class ? input.left_class : 's12 m6 clm'">
           <qt-input-text :iuid="iuid" />
         </div>
         <div :class="input.right_class ? input.right_class : 's12 m6 clm'">
             <qt-button :iuid="iuid" />
         </div>
    </div>
`;

export default {
    name: 'b-intro-zip',
    template,
    props: ['iuid'],
    components: {
        'b-label': Label,
        'qt-button': Button,
        'qt-input-text': InputText,
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    mounted: function(){

    },
    methods: {

    }
};
